import { render, staticRenderFns } from "./admin-export-import.vue?vue&type=template&id=0d07786c&scoped=true"
import script from "./admin-export-import.vue?vue&type=script&lang=js"
export * from "./admin-export-import.vue?vue&type=script&lang=js"
import style0 from "./admin-export-import.vue?vue&type=style&index=0&id=0d07786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07786c",
  null
  
)

export default component.exports